import { BudgetItem } from '@/models/budget'

/**
 * Synchronizes local line item IDs with saved line items.
 * @param localItems - The local line items.
 * @param savedItems - The saved line items.
 * @returns The updated local line items with synced IDs.
 */
export const syncLineItemIds = (
  localItems: BudgetItem[],
  savedItems: BudgetItem[]
): BudgetItem[] => {
  return localItems.map((item) => {
    const savedItem = savedItems.find(
      (i) => i.weight === item.weight && i.category.weight === item.category.weight
    )
    if (savedItem) {
      return {
        ...item,
        id: savedItem.id,
      }
    }
    return item
  })
}
